import { colors } from '@alixpartners/ui-components';
import { Helper } from 'Explore/LastUpload/LastUpload.styles';

const { default: styled } = require('styled-components');

// Styled components
export const Container = styled.div`
	display: flex;
	width: 80%;
	justify-content: end;
`;

export const StyledHelper = styled(Helper)`
	margin: 15px 10px 0 0;
	font-size: 12px;
`;

export const DropDownWrapper = styled.div`
	margin-top: 5px;
	border: 1px solid ${colors.grey300};
	height: 32px;
	button {
		height: 30px;
	}
`;
